import * as React from 'react';

import { createIcon } from '../Icon';
export const FramerIcon = createIcon(
  <path d="M5 16V9h14V2H5l14 14h-7m-7 0l7 7v-7m-7 0h7" />,
  'FramerIcon'
);
